<template>
	<search-list ref="sl" :pageSizes="[25,30,40]" apiPath="/blackIP/list" hide-apply>
	<mm-lc title="Batch Edit">
		<template>
			<el-dropdown size="mini" trigger="click">
				<el-button size="small" type="primary">
					<i class="el-icon-edit"></i>More Operaction
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item class="status-active" @click.native="changeStatus('active')">Switch to Active</el-dropdown-item>
					<el-dropdown-item class="status-paused" @click.native="changeStatus('pause')">Switch to Pause</el-dropdown-item>
					<el-dropdown-item @click.native="delBlackIps()">Delete Record</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</template>
	</mm-lc>
	<mm-lc title="Add Black IP">
		<el-button type="success" size="small" @click="createBlackIp">Create</el-button>
	</mm-lc>
		<!-- <el-button slot="actions" type="success" class="el-icon-circle-plus bt-create" @click="createBlackIp"></el-button> -->
		<div slot="actions" />
			<mm-table slot="dataTable" slot-scope="res" :res="res" @selection-change="selectRules">
			<el-table-column type="selection"></el-table-column>
			<el-table-column label="IP" prop="ip" />
			<el-table-column label="Manager" prop="pm"/>
			<el-table-column label="status" prop="status">
				<span slot-scope="sp" :class="sp.row.status=='active'?'status-active':'status-paused'">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Remark" prop="remark"/>
			<el-table-column label="Time">
				<div slot-scope="sp">
					<div>{{sp.row.createdAt}}</div>
					<div>{{sp.row.updatedAt}}</div>
				</div>
			</el-table-column>
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item class="status-active" @click.native="ipStatus(sp.row,'active')">Switch to Active</el-dropdown-item>
							<el-dropdown-item class="status-paused" @click.native="ipStatus(sp.row,'pause')">Switch to Pause</el-dropdown-item>
							<el-dropdown-item @click.native="ipStatus(sp.row,'delete')">Delete Record</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>

		</mm-table>

	</search-list>
</template>

<script>
export default {
	data() {
		return {
			ip_arr:[],
		};
	},
	methods: {
		selectRules(ip_arr){
			this.ip_arr = ip_arr;
		},
		createBlackIp(){
			this.$router.push({ path: "/blackIpCreate" });
		},
		async ipStatus(ip,status){
			this.ip_arr = [];
			this.ip_arr.push(ip);
			if(status === 'delete'){
				await this.delBlackIps();
			}else {
				await this.changeStatus(status);
			}
		},
		async changeStatus(status){
			if(this.ip_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Change'
				});
				return;
			}
			let ids = [];
			for (const ip of this.ip_arr) {
				ids.push([ip.id]);
			}
			
			const result = await this.$post('/blackIP/updateAll',{status:status,ids:ids});
			this.$refs.sl.refresh();
		},
		async delBlackIps(){
			if(this.ip_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Delete'
				});
				return;
			}
			try {
				await this.$confirm('Do you want to delete these rules?', 'WARING', {
				confirmButtonText: 'Yes',
				cancelButtonText: 'No',
				type: 'warning'
				});
				let ids = [];
				for (const ip of this.ip_arr) {
					ids.push([ip.id]);
				}
				const result = await this.$post('/advChannelRule/delAll',{ids:ids});
				this.$refs.sl.refresh();
			} catch (error) {
				this.$message({
					type: 'info',
					message: error
				})
			}
		}
	}

};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
